import { injectIntl } from "react-intl";
import { OperationType } from "src/helpers/Enums";
import MenuIcon from "src/components/MenuIcon";
import clsx from "clsx";

const Empty = (props) => {
  return (
    <div
      className={
        "flex flex-col w-full min-h-screen justify-center items-center gap-4"
      }
    >
      <MenuIcon menu={props.menu} color={"#7E50EA"} size={"64"} />
      <div className={"flex flex-col gap-[6px] justify-center items-center"}>
        <div className={"EmptyCaseTitle"}>{props.title}</div>
        <div className={"EmptyCaseDescription"}>{props.description}</div>
      </div>
      {props.noButton !== true && (
        <button
          className={clsx("PrimaryButton", "w-[220px]")}
          onClick={() => props.handleNew(OperationType.CREATE, null)}
        >
          <img
            alt={"Logo"}
            src={"/media/icons/plusIcon.svg"}
            className={"w-4 h-4"}
          />
          New {props.type}
        </button>
      )}
      {props.type === "Schedule" && (
        <button
          className={clsx("SecondaryButton", "w-[220px]")}
          onClick={() => {
            props.setDate(new Date());
            props.setIsUpdate(true);
          }}
        >
          Go To Current Month
        </button>
      )}
    </div>
  );
};

export default injectIntl(Empty);
